// extracted by mini-css-extract-plugin
module.exports = {"anonymousAuth":"styles_anonymousAuth__2Vryx","controls":"styles_controls__30vWV","warning":"styles_warning__PUgvS","label":"styles_label__1UrOJ","enabled":"styles_enabled__2rQLc"};